import React, {useState} from 'react'
import FarmerSurveyTemplateForm from './FarmerSurveyTemplateForm';
import FarmerSurveyTemplateList from './FarmerSurveyTemplateList';

const FarmerSurveyTemplate = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FarmerSurveyTemplateForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <FarmerSurveyTemplateList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
    </>
  )
}

export default FarmerSurveyTemplate
